import { File, type LucideIcon } from 'lucide-react';
import { exactLeaf, type NavLeaf } from './navLeaves';
import type { RecentPlace } from './recentPlaces';
import { tabKey, type OpenTab } from './openTabs';

export interface TabDescription {
  label: string;
  icon: LucideIcon;
  /** Bereich der Navigation, zu dem die Seite gehört — steht im Tooltip, wenn er nicht schon der Titel ist. */
  area: string | null;
}

function pathOf(to: string): string {
  return to.split('?')[0];
}

/** Bereich mit dem längsten passenden Pfad (`/crm/123` → „Kunden & Lieferanten“). */
function areaLeaf(key: string, leaves: NavLeaf[]): NavLeaf | undefined {
  let best: NavLeaf | undefined;
  for (const leaf of leaves) {
    const path = pathOf(leaf.to);
    const isMatch = path === '/' ? key === '/' : key === path || key.startsWith(`${path}/`);
    if (isMatch && (!best || path.length > pathOf(best.to).length)) best = leaf;
  }
  return best;
}

/**
 * Beschriftung eines Tabs. Reihenfolge: Titel der Seite (Brotkrumen,
 * `useTabTitle`) → gemerkter Datensatz aus „Zuletzt geöffnet" → Navigations-
 * punkt genau dieser Adresse → Überschrift der Seite → Bereich der Navigation.
 * Das Symbol ist immer das des Bereichs, damit gleichartige Tabs gleich aussehen.
 */
export function describeTab(tab: OpenTab, leaves: NavLeaf[], recents: RecentPlace[]): TabDescription {
  const key = tabKey(tab.path);
  const url = new URL(tab.path, 'https://proerp.invalid');
  const exact = exactLeaf(leaves, url.pathname, url.search);
  const area = areaLeaf(key, leaves);
  const recent = recents.find((place) => tabKey(place.path) === key);
  const label = tab.title ?? recent?.label ?? exact?.label ?? tab.heading ?? area?.label ?? 'Seite';
  const areaLabel = (exact ?? area)?.parentLabel ?? area?.label ?? null;
  return { label, icon: (exact ?? area)?.icon ?? File, area: areaLabel && areaLabel !== label ? areaLabel : null };
}
